module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-fr3.2263b97.png";